export const CODE_SPACE_OUTSIDE = '此处内联代码的外部需要一个空格'
export const CODE_NOSPACE_OUTSIDE = '此处内联代码的外部不需要空格'

export const MARKDOWN_SPACE_OUTSIDE = '此处 Markdown 标记的空格需要在外部'
export const MARKDOWN_NOSPACE_INSIDE = '此处 Markdown 标记的内部不需要空格'

export const PUNCTUATION_UNIFICATION = '此处字符需要统一'
export const PUNCTUATION_UNIFICATION_TRADITIONAL = '此处标点符号需要统一到繁体'
export const PUNCTUATION_UNIFICATION_SIMPLIFIED = '此处标点符号需要统一到简体'

export const PUNCTUATION_FULL_WIDTH = '此处标点符号需要使用全角'
export const PUNCTUATION_HALF_WIDTH = '此处标点符号需要使用半角'

export const PUNCTUATION_NOSPACE_BEFORE = '此处标点符号前不需要空格'
export const PUNCTUATION_NOSPACE_AFTER = '此处标点符号后不需要空格'
export const PUNCTUATION_SPACE_AFTER = '此处标点符号后需要一个空格'

export const BRACKET_NOSPACE_INSIDE = '此处括号的内部不需要空格'
export const BRACKET_NOSPACE_OUTSIDE = '此处括号的外部不需要空格'
export const BRACKET_SPACE_OUTSIDE = '此处括号的外部需要一个空格'

export const CONTENT_SPACE_HALF_WIDTH = '此处半角内容之间需要一个空格'
export const CONTENT_NOSPACE_FULL_WIDTH = '此处全角内容之间不需要空格'
export const CONTENT_SPACE_MIXED_WIDTH = '此处中英文内容之间需要一个空格'
export const CONTENT_NOSPACE_MIXED_WIDTH = '此处中英文内容之间需要一个空格'

export const QUOTATION_NOSPACE_INSIDE = '此处引号的内部不需要空格'
export const QUOTATION_NOSPACE_OUTSIDE = '此处引号的外部不需要空格'
export const QUOTATION_SPACE_OUTSIDE = '此处引号的外部需要一个空格'

export const TRIM_SPACE = '此处需要去除外部空格'
